import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import {
  AccountSnapshot,
  ActionItems,
  News,
  UserManual,
  TotalUnbilledTraffic,
} from '@components/Dashboard';

export const Dashboard = () => {
  const { isPrepaid } = useSelector((state) => state.auth.user);
  return (
    <>
      <Row>
        <Col md={7}>
          <ActionItems />
        </Col>
        <Col md={5}>
          {!isPrepaid && (
            <div className="mb-3">
              <TotalUnbilledTraffic />
            </div>
          )}
          <News />
        </Col>
      </Row>
      <Row className="py-3">
        <Col md={7}>
          <AccountSnapshot />
        </Col>
        <Col md={5}>
          <UserManual />
        </Col>
      </Row>
    </>
  );
};
